// extracted by mini-css-extract-plugin
export var active = "_85-a";
export var activeIndicator = "_85-8";
export var animate = "_85-9";
export var disabled = "_85-b";
export var fullWidth = "_85-2";
export var lg = "_85-7";
export var md = "_85-6";
export var redoButtonTabGroup = "_85-0";
export var sm = "_85-5";
export var tabButton = "_85-3";
export var tabButtonsContainer = "_85-1";
export var xs = "_85-4";